import "./styles.css";

function Header() {
  return (
    <header>
      <div className="container">
        <h3 className="logo">CONDOMÍNIO ABDON</h3>
      </div>
    </header>
  );
}

export default Header;
